import { Controller } from "@hotwired/stimulus"

// A form's success message: fades out after a few seconds, then leaves the
// page, so the form reads as it was.
export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 } }

  connect() {
    this.timer = setTimeout(() => this.leave(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  leave() {
    this.element.classList.add("leaving")
    this.element.addEventListener("transitionend", () => this.element.remove(), { once: true })
  }
}
